import palette from "../../../utilities/palette";
import { Box, Fade, Tooltip } from "@mui/material";
import SyncIcon from '@mui/icons-material/Sync';

export const ResetValueButton = ({
    isPrefilledByCatalog,
    isPrefilledValueChanged,

    onClick = () => {
        console.log("Default onClick function triggered");
     },
}) => {

    return (
        <Tooltip
        placement="top-end"
        title={"Reset to prefilled value"}>
            {
                <Fade in={isPrefilledByCatalog && isPrefilledValueChanged} timeout={500}>
                <Box
                    sx={{
                        marginLeft: "5px",
                        cursor: "pointer",
                        alignSelf: "center",
                        display: "flex"
                    }}
                    >
                    <SyncIcon 
                        sx={{
                            color: palette.main,
                            alignSelf: "center",
                            transition: 'transform 0.5s ease-in-out',
                            '&:hover': {
                                transform: 'rotate(-360deg)',
                            }
                            }}
                            onClick={() => {
                                onClick();
                            }}
                    />
                        
                </Box>
             </Fade>
            }
        </Tooltip>
    )
}